import { updateKlines, updateAllKlines, updateOrderBooks, updateMarkets } from './eventSubscriber';
import reduxStore from 'store';
export async function handlePing({ data, socket }) {
  if (socket?.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify({ pong: data.ping }));
  }
}

export async function handleMarketData(data, setState) {
  if (!data || !data.ch) return;
  
  // Handle market.overviewv2 separately as it has different structure
  if (data.ch === 'market.overviewv2') {
    handleOverviewV2Data(data, setState);
    return;
  }
  
  const [market, symbol, dataType] = data.ch.split('.');

  try {
    switch (dataType) {
      case 'trade':
        if (data.tick?.data) {
          const tradeData = {
            symbol: symbol.toUpperCase(),
            price: data.tick.data[0]?.price,
            amount: data.tick.data[0]?.amount,
            direction: data.tick.data[0]?.direction,
            timestamp: data.tick.data[0]?.ts
          };
          setState(prevState => ({
            ...prevState,
            trades: {
              ...prevState.trades,
              [symbol]: [tradeData, ...(prevState.trades?.[symbol] || []).slice(0, 19)]
            }
          }));
        }
        break;
        
      case 'depth':
        if (data.tick) {
          const orderBookData = {
            pairName: symbol.toUpperCase(),
            bids: data.tick.bids || [],
            asks: data.tick.asks || [],
            timestamp: data.tick.ts || Date.now()
          };
          setState(prevState => ({
            ...prevState,
            orderBooks: updateOrderBooks(prevState.orderBooks || [], orderBookData)
          }));
        }
        break;

      case 'detail':
        const market = reduxStore.store?.getState()?.crypto?.markets?.markets?.find(mrk => mrk.symbol === symbol) || {}
        if (data.tick) {
          setState(prevState => ({
            ...prevState,
            markets: updateMarkets(prevState.markets || [], {...data.tick, symbol: symbol, pairName: market.pairName, volume: data.tick.vol})
          }));
        }
        break;

    }
  } catch (error) {
    console.error('Error processing market data:', error);
  }
}

// Handle market.overviewv2 data for frequent market updates
function handleOverviewV2Data(data, setState) {
  try {
    if (!data.data)
      return;
    
    console.log('Processing market.overviewv2 data:', data.data.length, 'markets');
    
    // Transform overviewv2 data to match our market format
    const marketsData = Object.entries(data.data).map(([symbol, market]) => ({
      symbol: market.s,
      pairName: market.s.toUpperCase(),
      open: market.o,
      high: market.h,
      low: market.l,
      close: market.c,
      amount: market.a,
      vol: market.v,
      count: market.t,
      bid: market.b,
      ask: market.a,
      timestamp: Date.now()
    }));
    
    // Update state with all market data
    setState(prevState => ({
      ...prevState,
      markets: updateMarkets(prevState.markets || [], marketsData)
    }));
    
  } catch (error) {
    console.error('Error processing overviewv2 data:', error);
  }
}
